// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import ListaNotificaciones from '../../../componentesEspeciales/notificaciones/listaNotificaciones';
// estilos
import '../../../estilos/usuario.css';



function NotificacionesComprador() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, cargandoUsuario]);
    








    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Notificaciones</h1>
                    </div>
                </div>
            </div>

            <ListaNotificaciones usuario={usuario} rolDestino="Comprador" />

        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default NotificacionesComprador;